<template>
	<v-layout row wrap  page class="page-wrap">
	 	<v-flex xs12 class="text-xs-left" v-if="flightDetail">
	 		<div class="col-12 px-1 spacetop">
	      	  <h4 class="text-dark"> ({{flightDetail.id}}) {{flightDetail.name}}
          	 </h4>
	        	<div class="text after-flag cusfont16px al-top" ><span alt="salesperson" class="">
            {{filteredFlightType(flightDetail)}}</span> </div>

	        	<div class="sl-date font-blue cusfont16px date al-top">{{flightDetail.start_date | format_date}} - {{flightDetail.end_date | format_date}} {{flightDetail.totalday}}</div>
	   		</div>
	 	</v-flex>
	 	<v-flex xs11 class="text-xs-left distancerow"  v-if="flightDetail">
		    <div class="btn-group pull-left al-left">
		    	<router-link :to="`/detail/${flightDetail.campaign_id}/0`" >
	                <v-btn color="white" small class="btn-secondary space">
	                  Back
	                </v-btn>
                </router-link>

	        </div>
	        <div class="btn-group pull-right" v-if="!searching.stDate">
	        	<div class="text-muted font-light" >
	        		 <v-btn
			          color="grey"
			          class="search"
			          @click="openTestDialog($event,'date_filter',flightDetail.start_date,flightDetail.end_date1,flightDetail.id)"
			        >
			          <span class="txtdate" >{{flightDetail.start_date | format_date}} - {{flightDetail.end_date1 | format_date}} </span>
			        <i class="fa fa-search searchicon"></i>
			        </v-btn>
	        		<!-- <a class="btn search waves-effect waves-light btn-secondary" href="#" role="button">asdadasd<i class="fa fa-search searchicon"></i></a> -->
           		</div>

           		 <Date-Flight-Dialog  v-model="date_filter"
                      :flightId="flightId"
                      :sdate="flightDetail.start_date"
                      :edate="flightDetail.end_date1"
                       ref="form1"
                       modalTitle="flightReport"/>

	        </div>
	         <div class="btn-group pull-right" v-else-if="searching.stDate">
	        	<div class="text-muted font-light" >
	        		 <v-btn
			          color="grey"
			          class="search"
			          @click="openTestDialog($event,'date_filter',searching.stDate,searching.edDate,flightDetail.id)"
			        >
			          <span class="txtdate" >{{searching.stDate | format_date}} - {{searching.edDate | format_date}} </span>
			        <i class="fa fa-search searchicon"></i>
			        </v-btn>
	        		<!-- <a class="btn search waves-effect waves-light btn-secondary" href="#" role="button">asdadasd<i class="fa fa-search searchicon"></i></a> -->
           		</div>

           		 <Date-Flight-Dialog  v-model="date_filter"
                      :flightId="flightId"
                      :sdate="searching.stDate"
                      :edate="searching.edDate"
                       ref="form1"
                       modalTitle="flightReport"/>

	        </div>
	        <div class="clearfix"></div>

       </v-flex>

		<v-flex xs12 class="px-1">
			<div class="card-body1">
				<div class="col-12 px-1">
	           		<span class="text-muted">Impression </span>
	           		<span class="fright font-bold">{{camdetail.totalimpression | format_numberS}}</span>
	           </div>
	            <div class="col-12 px-1" v-if="camdetail.totalEngagement > 0">
	           		<span class="text-muted">Engagement </span>
	           		<span class="fright font-bold">{{camdetail.totalEngagement | format_numberS}}</span>
	       		</div>
	       		<div class="col-12 px-1"  v-if="camdetail.totalEngagement > 0">
	           		<span class="text-muted">ER </span>
	           		<span class="fright font-bold">{{camdetail.totalER | numofpercent}}% </span>
	           </div>
	           <div class="col-12 px-1">
	           		<span class="text-muted">Click </span>
	           		<span class="fright font-bold">{{camdetail.totalclick| format_numberS}} </span>
	           </div>
	            <div class="col-12 px-1">
	           		<span class="text-muted">CTR </span>
	           		<span class="fright font-bold">{{camdetail.avdClk | numofpercent}}% </span>
	           </div>

			</div>
		</v-flex>
		 <v-flex class="spacetop" >
	      	 <v-card color="white-grey darken-2" class="grey--text">
	      	 	<v-toolbar  dark class="card-header ">
	      	 	 	 <h5 class="m-b-0 text-white">
	                    Flight Stats
	                </h5>
	      	 	</v-toolbar>

	      	 	 <div class="card-body" v-if="total_record > 0">

                    <ul class="search-listing" >
                        <li v-if="index <= displayFlightReports.length"   v-for="index in page_length" :key="index" >
	                        <div class="pull-left font-blue cusfont16px date">
	                         {{displayFlightReports[index-1].date | format_date}}
	                        </div>
	                        <div class="clearfix"></div>
	                        <div class="flight_details">
	                            <div>
	                                <span class="text-muted">Impression </span>
	                                <span class="fright font-bold">{{displayFlightReports[index-1].views | format_numberS}}</span>
	                            </div>

	                            <div v-if="displayFlightReports[index-1].engagement > 0">
                                    <span class="text-muted">Engagement </span>
                                    <span class="fright font-bold">{{displayFlightReports[index-1].engagement | format_numberS}}</span>
                                </div>
                                <div v-if="displayFlightReports[index-1].engagement > 0">
                                    <span class="text-muted">ER</span>
                                    <span class="fright font-bold">{{getER(displayFlightReports[index-1]) | numofpercent}}% </span>
                                </div>
                                <div>
                                    <span class="text-muted">Click </span>
                                    <span class="fright font-bold">{{displayFlightReports[index-1].clicks | format_numberS}}</span>
                                </div>
                                <div>
	                                <span class="text-muted">CTR </span>
	                                <span class="fright font-bold">{{displayFlightReports[index-1].ctr | numofpercent}}%</span>
                            	</div>

	                        </div>
                   		</li>

                         <li id="loadMoreListItem" style="border-bottom: none; padding:0" v-show="showPage">

	                      <div class="text-center pt-2 paging-title"  v-if="!isPage">
	                        <a @click="pageChangeHandle(total_record)" > Load More </a>
	                      </div>
	                      <div class="text-center pt-2 paging-title" v-else>
	                         <v-progress-linear :indeterminate="true" class="loadingpbar txt-al"></v-progress-linear>
	                      </div>
                 	   </li>
                 <!--    <li id="loadMoreListItem" style="border-bottom: none; padding:0">
                        <div class="text-center pt-2" id="loadMore" style="cursor:pointer; color:#007bff">Load more</div>
                    </li>  -->

                	</ul>
            	</div>
            	<div class="card-body card-title " style="font-size: 16px;" v-else>
            		No Data Found
            	</div>
	      	</v-card>
	     </v-flex>
	</v-layout>

</template>
<style scoped>
	.btn-secondary {
	   /* border: 1px solid #727b84 !important;
	    color: #26c6da;*/
	}
	.btn-secondary:hover {
	    color: #fff;
	    background-color: #5a6268;
	    border-color: #545b62;
	}
	.after-flag {
		padding: 3px 0px;
	}
	.cusbuttonw{
		width: 81px;
	}
	.space{
		margin-right: -3px;

	}
	.flight_details{
		margin-top: 17px;
	}
	.v-btn {
		 min-width: 58px;
	    text-transform: capitalize !important;
	    height: 36px;
	    border-radius: 3px ;
	    font-size: 15px;
	}
	.pull-right{
	  margin-right: -33px;
	}

	.card-title{
		line-height: 0% !important;
    	display: block;
   		height: auto;
	}
</style>
<script>
   import { loginService } from '@/components/_service/Users.js'
   import { StatusColor,CurrencyCode,StatusValue } from '@/components/_service/Config.js'
   import DateFlightDialog from '@/components/DateFlightDialog';
   import { format, addYears, differenceInDays } from 'date-fns';
   // import moment from 'moment'
   export default {
	    name: 'ReportDetail',
	    components: {
	      DateFlightDialog,

   		 },
	     data () {
	      return {
	      	activeColor:"#F90648",
	      	status:"",
	      	stValue:"",
	      	id: "",
	        country:"flag-my",
	        currency:"MY",
	        AIOAcess:false,
	        flightId:"",
	        search:{},
	        flight_type:"Ad Network",
	        date_filter:false,
	        sdate:"",
	        edate:"",
	        isModalVisible:false,
	        loading:false,
	        currentPage: 0,
	        page_length:10,
	    	total_page:0,
	        showPage:true,
	        isPage:false,
	        pages:[],
	        flightreport:[],
	        queue:[],



	      }
	  	},
	   computed:{
	    	flightDetail(){
				return this.$store.getters.loadedFlightDetail;

			},
			displayFlightReports(){
				return this.$store.getters.loadedFlightReport;
			},
			camdetail(){

				return this.$store.getters.loadedFlightEleReport;
			},

			searching(){
				return  this.$store.state.searching
			},
			total_record(){
				return this.$store.getters.loadedFlightReportTotalRecord;
			}

	  	},
	  	beforeUpdated(){
	  		// console.log(this.$store.getters.loadedFlightReportTotalRecord)
	  		// this.total_page = Math.ceil(this.$store.getters.loadedFlightReportTotalRecord/this.page_length);

	  		// if (this.total_page  === 0 || this.total_page == 1){
		   //      this.showPage = false
	    //     }
	  	},

	  	updated(){

	  		this.total_page = Math.ceil(this.$store.getters.loadedFlightReportTotalRecord/this.page_length);
	  	//	console.log(this.total_page)
	  		if (this.total_page  == 0 || this.total_page == 1){
		        this.showPage = false
	        }else if(this.total_page > 1){
	        	this.showPage = true
	        }

	  	},

	  	mounted(){
			this.id = this.$route.params.id;
			this.getFlight();
			this.total_page = Math.ceil(this.$store.getters.loadedFlightReportTotalRecord/this.page_length);




  		},
  		created(){

			this.getFlight();
			if (this.$route.query.q){
	        	const dataAr= this.$route.query.q.split(",");

	        	const stDate =dataAr[0];  // format(dataAr[0],'DD MMM ,YYYY');
			    const edDate =dataAr[1]; //format(dataAr[1],'DD MMM ,YYYY');

	        	this.search={stDate,edDate,id:this.id,page:this.currentPage};
	        }

	  	},
  		watch: {

		},
	    methods:{
	    	getFlight () {
	    		const stDate ="";
	    		const edDate ="";
    		 	if (this.id !==""){


			        // console.log(this.sdate )
			        // console.log(this.edate)
	    		  	if (this.sdate !=="" && this.edate !==""){
	    		  		 stDate = format(new Date(this.sdate),'YYYYMMDD'); // moment(this.input_startdate).format('YYYYMMDD')
						 edDate =format(new Date(this.sdate),'YYYYMMDD');
	    		  	}

			       if (this.$route.query.q){
			        	const dataAr= this.$route.query.q.split(",");
			        	//console.log(dataAr)
			        	this.sdate =dataAr[0];  // format(dataAr[0],'DD MMM ,YYYY');
					    this.edate =dataAr[1]; //format(dataAr[1],'DD MMM ,YYYY');

			        	//this.search={stDate,edDate,id:this.id,page:this.currentPage};
			        }

	    		  	this.search={stDate,edDate,"id":this.id,page:this.currentPage};
	    		  	//console.log(this.search)
	    		  	this.$store.dispatch('flightFilterDate', this.search);

	       	 	}
        	},
        	pageChangeHandle(total_record){

				let numberOfPages =  Math.ceil(total_record/this.page_length);

				this.isPage = true


	        	if (this.currentPage < numberOfPages)  {

	         		this.currentPage ++;
	         		//
	       	 		setTimeout(() => {
	       	 			this.page_length +=10;


	                    this.isPage = false
	              //       if (this.currentPage ==numberOfPages ){
	         	 			// this.showPage =false
	              //       }
	                },2000)
		           //  return this.page_length;
	         	 }else{
	         	 	 this.showPage =false
	         	 	 this.isPage = false
	         	}


        	},


	       	filteredFlightType(item1){
	           if (item1.platform && item1.flight_type=="premium"){
	              this.flight_type="Premium"
	           }
	           return this.flight_type
	        },
	        openTestDialog (e,s,sd,ed,n) {
	          if (s == 'date_filter'){
	            this.date_filter =true;
	            this.sdate =sd;
	            this.edate =ed;
	          }

	          this.flightId = n

      		},
      		backToDetail(camid){
      			this.$router.push({ name: 'detail', params: { id: camid,flightid:0  } })

			},
			getER(item){

	  			if(item.engagement > 0){
	  			 	return (item.engagement/item.views)*100
	  			 }else
	  				return

	  		},

		},



   }
</script>
